module.exports = __webpack_public_path__ + "img/story_cover.a93455e6.jpg";